export default __webpack_public_path__ + "static/media/welcomeText.86333ab2.png";